import * as React from 'react';

const Spinner = () => {
	return (
		<div className="loaderWithDots">
			<div />
			<div />
			<div />
		</div>
	);
};

export { Spinner };
